import { Caption, MarkDown, Modal, useToast } from "@wayflyer/flyui";
import { useCallback, useState } from "react";
import { useIntl } from "react-intl";

export interface BankConnectConsentModalProps {
  providerName: string;
  consentHandler: () => Promise<void>;
  close: () => void;
  isOpen: boolean;
}

export const BankConnectConsentModal = ({
  providerName,
  consentHandler,
  close,
  isOpen,
}: BankConnectConsentModalProps) => {
  const intl = useIntl();
  const toaster = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = useCallback(async () => {
    setIsLoading(true);
    try {
      await consentHandler();
      close();
    } catch (error) {
      toaster?.critical(error as string); //TODO i18n
    }
    setIsLoading(false);
  }, [close, consentHandler, toaster]);

  return (
    <Modal
      title={intl.formatMessage({
        id: "shared-ui: bank connect consent - modal title",
        defaultMessage: "Access to your bank is required",
      })}
      primaryAction={{
        content: intl.formatMessage({ id: "shared-ui: Agree", defaultMessage: "Agree" }),
        onAction: handleConfirm,
        loading: isLoading,
      }}
      tertiaryAction={{
        content: intl.formatMessage({ id: "shared-ui: Cancel", defaultMessage: "Cancel" }),
        onAction: close,
      }}
      isOpen={isOpen}
      onClose={close}
    >
      <div>
        <MarkDown
          markdown={intl.formatMessage(
            {
              id: "shared-ui: bank connect consent - modal body",
              defaultMessage:
                "We use {providerName} to connect to your bank account. To proceed with connection, you must agree to our [Terms & Conditions](https://www.wayflyer.com/privacy-notice)",
            },
            { providerName }
          )}
        />
        <Caption>
          {intl.formatMessage({
            id: "shared-ui: Your data is securely encrypted",
            defaultMessage: "Your data is securely encrypted",
          })}
        </Caption>
      </div>
    </Modal>
  );
};
